import React, { useRef, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Badge from '@mui/material/Badge';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { format,parseISO } from 'date-fns'



const drawerWidth = 300;
const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    appBarBottom: {
        top: 'auto',
        bottom: 0,
        [theme.breakpoints.up('sm')]: {
        },
    },
    grow: {
        flexGrow: 1,
    },
    productListPaper: {

        marginBottom: 50,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const materialTheme = createTheme(({
    // set default for now
  }));



function SalesOrderProductsReview(props) {
    const classes = useStyles();
    const [products, setProducts] = useState([]);
    const [showErrorMessage,setShowErrorMessage] = useState(false)
    const [openLotNumberAndExpirationDialogInput,setOpenLotNumberAndExpirationDialogInput] = useState(false)
    const [selectedUOMWithLotNumberAndExpiration,setSelectedUOMWithLotNumberAndExpiration] = useState(null)



    function formatDate(dateString){
        try {
          return format(parseISO(dateString), 'MMMM d,yyyy')
        }catch(err){
          return ""
        }
    }

    function orderValue(product,unit) {
        
        return unit.to_receive_quantity <= 0 ? '' : unit.to_receive_quantity
    }

    const quantityInputOnChange = (product,unit)=>(event)=>{

         const newProducts = [...products]
         unit.to_receive_quantity = event.target.value
         setProducts(newProducts)
      }

    function computeTotalAmountPerProduct(product){
        const totalOrderValue = Number(product.uoms.reduce((partialSum,unit)=>{
    
            if (unit.to_receive_quantity === null) {
                return  partialSum + 0
            }
            
            if(unit.to_receive_quantity.length <=0){
                return partialSum + 0
            }else{
              
                return partialSum + parseFloat(unit.to_receive_quantity) * unit.price_with_tax;
            }
          
        },0.00 ))

        return Number(totalOrderValue.toFixed(2)).toLocaleString('en-US', {maximumFractionDigits:2})

    }
    function computeTotalAmoun(){
          const totalAmount = products.reduce((totalPartialSum,product)=>{
            const totalOrderValue = Number(product.uoms.reduce((partialSum,unit)=>{
                
                if (unit.to_receive_quantity === null) {
                    return  partialSum + 0
                }

                if(unit.to_receive_quantity.length <=0){
                    return partialSum + 0
                }else{
                  
                    return partialSum + parseFloat(unit.to_receive_quantity) * unit.price_with_tax;
                }
              
            },0.00 ))
            return  totalPartialSum + totalOrderValue
          },0.00)

          return Number(totalAmount.toFixed(2)).toLocaleString('en-US', {maximumFractionDigits:2})
    }
    function totalOrderItemCount(){
        const totalAmount = products.reduce((totalPartialSum,product)=>{
            const totalOrderValue = Number(product.uoms.reduce((partialSum,unit)=>{
    
                if(unit.order_quantity.length <=0){
                    return partialSum + 0
                }else{
                  
                    return partialSum + 1
                }
              
            },0 ))
            return  totalPartialSum + totalOrderValue
          },0)

          return Number(totalAmount.toFixed(2)).toLocaleString('en-US', {maximumFractionDigits:0})
    }

    function orderInput(product, unit) {
        return (
            <Box display="flex" justifyContent="flex-end" >
                <Box p={1} display="flex" justifyContent="center" flexDirection="column">
                    <Typography variant="h6" component="span" style={{ fontWeight: 600, fontSize: "16px" }}>{unit.price_with_tax} / <small>{unit.uom}</small></Typography>
                </Box>
                <Box p={1} style={{ maxWidth: "100px" }}>
                    <TextField
                        id="outlined-size-small"
                        variant="outlined"
                        size="small"
                        type="number"
                        value={orderValue(product,unit)}
                        onChange={quantityInputOnChange(product,unit)}
                    />
                </Box>

            </Box>
        )
    }
    const lotNumberAndExpirationsInputOnChange = (lotNumberAndExpirations)=>(event)=>{
        const productCode = lotNumberAndExpirations.product_code
        const uom = lotNumberAndExpirations.uom
        const lotNumberAndExpirationId = lotNumberAndExpirations.id
        const value = event.target.value

        if(value.length <=0 || value <=0){
            lotNumberAndExpirations.to_receive_quantity = 0
        }else{
            lotNumberAndExpirations.to_receive_quantity = value
        }
        const productsCopy = [...products]

        
        const productIndex = findProductIndexByProductCode(productsCopy,productCode)
        const selectedProduct = productsCopy[productIndex]
        
        const uomIndex = findUomIndexByUom(selectedProduct.uoms,uom)
        const selectedUOM = selectedProduct.uoms[uomIndex]

        const totalToReveicedByUom = computeTotalToReceiveQuantityOfUom(selectedUOM)
        selectedUOM.to_receive_quantity = totalToReveicedByUom
        const lotNumberAndExpirationIndex = findLotNumberAndExpirationIndexById(selectedUOM.lotNumberAndExpirations,lotNumberAndExpirationId)
        
        const selectedLotNumberAndExpiration = selectedUOM.lotNumberAndExpirations[lotNumberAndExpirationIndex]
       
        setProducts(productsCopy)
    }  
    function computeTotalToReceiveQuantityOfUom(selectedUOM){
        let totalToReceived = 0
        selectedUOM.lotNumberAndExpirations.forEach((lotNumberAndExpiration)=>{
            totalToReceived += parseInt(lotNumberAndExpiration.to_receive_quantity)
        
        })
        return totalToReceived
    }
     
    function findProductIndexByProductCode(products, productCode){
        return products.findIndex((product)=>{
            return product.product_code == productCode
        })

    }

    function findUomIndexByUom(productUoms,uom){

        return productUoms.findIndex((productUom)=>{
            return productUom.uom == uom
        })

    }
    function findLotNumberAndExpirationIndexById(lotNumberAndExpirations,lotNumberAndExpirationId){

        return lotNumberAndExpirations.findIndex((lotNumberAndExpiration)=>{
            return lotNumberAndExpiration.id == lotNumberAndExpirationId
        })
    }  
    function lotNumberAndExpirationQuantity(lotNumberAndExpirations){
       

        return lotNumberAndExpirations.to_receive_quantity <= 0 ? '' : parseInt(lotNumberAndExpirations.to_receive_quantity)


    }  
    function orderInputWithLotNumberAndExpirations(product, unit) {
       
        return (
            <Box display="flex" justifyContent="flex-end" >
                <Box p={1} display="flex" justifyContent="center" flexDirection="column">
                    <Typography variant="h6" component="span" style={{ fontWeight: 600, fontSize: "16px" }}>{unit.price_with_tax} / <small>{unit.uom}</small></Typography>
                </Box>
                <Box p={1} style={{ maxWidth: "100px" }}>
                    <TextField
                        id="outlined-size-small"
                        variant="outlined"
                        size="small"
                        type="number"
                        value={orderValue(product,unit)}
                        onClick={(event)=>{
                            setSelectedUOMWithLotNumberAndExpiration(unit)
                            setOpenLotNumberAndExpirationDialogInput(true)
                            
                        }}
                        inputProps={
                            { readOnly: unit.has_lot_number_and_expiration, }
                        }
                    />
                </Box>

            </Box>
        )
    }

    function lotNumberAndExpirationsInput(lotNumberAndExpirations) {
       
       
        return (
            <Grid container style={{ padding: "0px" }}>
                <Grid container item xs={12} >
                   
                    <Grid item xs={9} md={10} lg={11}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="space-between"
                            alignItems="stretch">
                            <Grid item >
                                <Box style={{ fontWeight: 600, fontSize: "14px" }}>Lot #: {lotNumberAndExpirations.lot_number}</Box>
                                <Box style={{ fontWeight: 600, fontSize: "14px" }}>Exp. date: { formatDate(lotNumberAndExpirations.expirations)}</Box>

                            </Grid>
                         
                            
                            
                        </Grid>
                    </Grid>
                    <Grid item xs={3} md={2} lg={1}>
                    <Box display="flex" justifyContent="flex-end" >
                    <TextField
                            id="outlined-size-small"
                            variant="outlined"
                            size="small"
                            type="number"
                            value={lotNumberAndExpirationQuantity(lotNumberAndExpirations)}
                            onChange={lotNumberAndExpirationsInputOnChange(lotNumberAndExpirations)}
                        />
                    </Box>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
    function productElement(product) {
        return (
            <Grid container style={{ padding: "0px" }}>
                <Grid container item xs={12} >
                    < Grid item xs={3} md={2} lg={1} style={{ padding: "4px" }} container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justifyContent="center">
                        <img src={product.image} style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={9} md={10} lg={11}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="space-between"
                            alignItems="stretch">
                            <Grid item >
                                <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.brand}</Box>
                                <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.product_name}</Box>

                            </Grid>
                            <Grid item >
                                {
                                    product.uoms.map(unit => (
                                        <React.Fragment key={unit.id} >
                                            {unit.has_lot_number_and_expiration ?  orderInputWithLotNumberAndExpirations(product, unit):orderInput(product, unit)}
                                        </React.Fragment>
                                    )
                                    )
                                }


                            </Grid>
                            <Grid item style={{ fontWeight: 600, fontSize: "14px", color: "green" }}>Total : P {computeTotalAmountPerProduct(product)}</Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
    function productLists() {
        return (
            <List>
                {
                    products.map(product => (
                        <React.Fragment key={product.id}>
                            <ListItem >
                                {productElement(product)}
                            </ListItem>
                            <Divider light />
                        </React.Fragment>
                    )
                    )
                }
            </List>
        )
    }

    
    function sellerInformation(){
        if(typeof props.selectedSalesOrder !== 'undefined'){
            return   <Typography gutterBottom variant="subtitle1">Seller: {props.selectedSalesOrder.seller_name}<br/> Purchase Order #: {props.selectedSalesOrder.sales_order_number}</Typography>
        }
        
    }
    function salesOrderInformations() {
        return (
            <Grid container style={{padding:'1rem'}}>
                <Grid item xs={12} sm container>
                    <Grid item xs container direction="column" spacing={2}>
                        <Grid item xs>
                            {sellerInformation()}
                            
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
    function addToInvoiceClickEvent() {
        alert();
    }

    function checkProducts(){
        const newReviewedSalesOrderItems = []

        products.forEach((salesOrderItem)=>{
          const newSalesOrderItem = {...salesOrderItem}
          newSalesOrderItem.uoms = []
         
    
          salesOrderItem.uoms.forEach((uom)=>{
            const orderQuantity = uom.order_quantity
            if(Number(orderQuantity) > 0){
              newSalesOrderItem.uoms.push(uom)
            }
          })
    
          if(newSalesOrderItem.uoms.length > 0 ){
            newReviewedSalesOrderItems.push(newSalesOrderItem)
          }
        })
       
        props.openInvoiceInformationReviewDialogWithReviewedItems(newReviewedSalesOrderItems)
       
    }
    function lotNumberAndExpirationInputDialog(){
        if(selectedUOMWithLotNumberAndExpiration == null){
            return
        }

        return (
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                <Dialog 
                open={openLotNumberAndExpirationDialogInput} 
                onClose={()=>{setOpenLotNumberAndExpirationDialogInput(false)}}
                fullWidth={true}
                maxWidth="md">
                <DialogContent style={{padding:".4rem"}}>
                  
                    <Typography variant="h6" style={{color:'black'}} gutterBottom>
                    {selectedUOMWithLotNumberAndExpiration.product_name}
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                      <small>Unit :</small> {selectedUOMWithLotNumberAndExpiration.uom}
                    </Typography>
                   
                  <List style={{margin:"0px"}}>
                  {  
                    selectedUOMWithLotNumberAndExpiration.lotNumberAndExpirations.map(lotNumberAndExpiration => {
                        return(
                            <React.Fragment key={lotNumberAndExpiration.id}>
                            <ListItem style={{padding:".2rem"}}>
                            {lotNumberAndExpirationsInput(lotNumberAndExpiration)}
                            </ListItem>
                              <Divider light />
                              </React.Fragment>
                        )
                      
                        })
                  }
                  </List>
                </DialogContent>
                <DialogActions>
                  <Button  onClick={()=>{
                      setOpenLotNumberAndExpirationDialogInput(false)
                  }} color="primary">
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
              </ThemeProvider>
            </StyledEngineProvider>
        );
    }
    function messageDialog(){
        return (
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                <Dialog
                    fullWidth={true}
                    maxWidth={"md"}
                    open={showErrorMessage}
                    onClose={() => {}}
                    aria-labelledby="max-width-dialog-title"
                    >
                    <DialogTitle id="max-width-dialog-title">Error Message</DialogTitle>
                    <DialogContent>
                    <DialogContentText>Please input quantity.</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={()=>{setShowErrorMessage(false)}} color="primary">
                        Close
                    </Button>
                    </DialogActions>
              </Dialog>
              </ThemeProvider>
            </StyledEngineProvider>
        );
    }
    useEffect(()=>{
       
        if(props.selectedSalesOrder === null || props.selectedSalesOrder === undefined){
            return;
        }
        
        setProducts(props.reviewedSalesOrderItems)
    })
    return (
        <div>
            <Dialog fullScreen open={props.openSaleOrderProductReviewDialog} onClose={() => { props.setOpenSaleOrderProductReviewDialog(false) }} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => { props.setOpenSaleOrderProductReviewDialog(false) }}
                            aria-label="close"
                            size="large">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="subtitle1" className={classes.title}>
                            Products Review
                    </Typography>
                    </Toolbar>
                </AppBar>
                <div className={classes.appBarSpacer}></div>
                <Paper square className={classes.productListPaper}>
                    {salesOrderInformations()}
                    {productLists()}
                </Paper>
                <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
                    <Toolbar>
                        <Typography variant="subtitle1" noWrap>
                             Total :  {computeTotalAmoun()}
                        </Typography>
                        <div className={classes.grow} />

                        <Button variant="contained" onClick={() => {
                            if(totalOrderItemCount() <=0){
                               
                                setShowErrorMessage(true)
                                return
                            }
                            checkProducts()
                            
                         }} >
                            <Typography variant="caption">
                                Finalize Products
                            </Typography>
                            <Badge badgeContent={totalOrderItemCount()} color="secondary" style={{ marginLeft: "1rem" }} />
                        </Button>

                    </Toolbar>
                </AppBar>
                {lotNumberAndExpirationInputDialog()}
            </Dialog>

            {messageDialog()}
        </div>
    );
}

export default SalesOrderProductsReview